import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { LookerRiskDashboardType } from "../../looker-risk-dashboard-type.enum";
import { HideFilters } from "../../models/analytics-hide-filters.enum";

@Component({
  selector: "app-document-validation-report",
  templateUrl: "./document-validation-report.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DocumentValidationReportComponent {
 filters: string[] = ["Projects"];
 dashboardType = LookerRiskDashboardType.Document_Validation_Report_DW;
 hideFilters: string[] = [HideFilters.PROJECT_ID, HideFilters.USER_ID, HideFilters.ORG_ID];
}
